import { PopupCard } from '~containers/PopupResolver/PopupCard/PopupCard';
import { PopupTypes } from '~containers/PopupResolver/PopupResolver.types';

import { PopupBannerCommonProps } from './PopupBanner.types';

export function PopupBanner({
  isVisibleButtonClose,
  image,
  imageSettings,
  video,
  heading,
  text,
  buttons,
  isReversed,
  onClose,
  onTargetAction,
  active,
  opaque,
  isOverlayClose,
}: PopupBannerCommonProps) {
  return (
    <PopupCard
      type={PopupTypes.card}
      heading={heading}
      text={text}
      buttons={buttons}
      video={video}
      image={image}
      isReversed={isReversed}
      imageSettings={imageSettings}
      isVisibleButtonClose={isVisibleButtonClose}
      isOverlayClose={isOverlayClose}
      cardSize="s"
      popupMod="bottom"
      mod="gradient"
      scrollLock={false}
      onClose={onClose}
      onTargetAction={onTargetAction}
      active={active}
      opaque={opaque}
    />
  );
}
